module.exports = __webpack_public_path__ + "static/next-step-cover-632fa0f1d884d260d5825372398fa079.png";